<form>

  <div mat-dialog-content class="calibrates-theme">

    <div fxLayout="column" class="flexwrap">

      <div fxFlex>
        <mat-form-field class="campoFormulario">
          <mat-label>{{ 'calibrateEquipmentEdit.patterns.dialog.equipment.label' | translate }}</mat-label>
          <input matInput [ngModel]="equipmentName" #trigger="matAutocompleteTrigger" [matAutocomplete]="auto"
            (keyup)="lookupEquipment($event)" [ngModelOptions]="{standalone: true}" required>
          <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete"
            (optionSelected)="onEquipmentChange($event) ">
            @for (item of equipmentAutoComplete; track item; let index = $index) {
              <mat-option [value]="item">
                {{ item.name}} ({{item.serialNum}})
              </mat-option>
            }
          </mat-autocomplete>
          <mat-error>
            {{ 'calibrateEquipmentEdit.patterns.dialog.equipment.error' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      <div fxLayout="row" class="flexwrap">
        @if (this.data.pattern.idEquipment) {
          <div fxFlex="33" fxFlex.lt-md="100%">
            <mat-form-field class="campoFormulario">
              <input disabled matInput type="string" [(ngModel)]="data.pattern.equipment.name" name="name" required
                placeholder="{{ 'particlesPattern.dialog.equipment.name.label' | translate }}">
              <mat-error>
                {{ 'particlesPattern.dialog.equipment.name.error' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
       
          <div fxFlex="33" fxFlex.lt-md="100%">
            <mat-form-field class="campoFormulario">
              <input disabled matInput type="string" [(ngModel)]="data.pattern.equipment.maker" name="maker" required
                placeholder="{{ 'particlesPattern.dialog.equipment.maker.label' | translate }}">
              <mat-error>
                {{ 'particlesPattern.dialog.equipment.maker.error' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
       
          <div fxFlex="33" fxFlex.lt-md="100%">
            <mat-form-field class="campoFormulario">
              <input disabled matInput type="string" [(ngModel)]="data.pattern.equipment.model" name="model" required
                placeholder="{{ 'particlesPattern.dialog.equipment.model.label' | translate }}">
              <mat-error>
                {{ 'particlesPattern.dialog.equipment.model.error' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
        }
      </div>
      <div fxLayout="row" class="flexwrap">
        @if (this.data.pattern.idEquipment) {
          <div fxFlex="50" fxFlex.lt-md="100%">
            <mat-form-field class="campoFormulario">
              <input disabled matInput type="string" [(ngModel)]="data.pattern.equipment.serialNum" name="serialNum" required
                placeholder="{{ 'particlesPattern.dialog.equipment.serialNum.label' | translate }}">
              <mat-error>
                {{ 'particlesPattern.dialog.equipment.serialNumber.error' | translate }}z
              </mat-error>
            </mat-form-field>
          </div>
        
          <div fxFlex="50" fxFlex.lt-md="100%">
            <mat-form-field class="campoFormulario">
              <input disabled matInput type="string" [(ngModel)]="data.pattern.equipment.equipment" name="equipment" required
                placeholder="{{ 'particlesPattern.dialog.equipment.equipment.label' | translate }}">
              <mat-error>
                {{ 'particlesPattern.dialog.equipment.equipment.error' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
        }
      </div>

    </div>

  </div>
  <div mat-dialog-actions class="calibrates-theme">
    <div fxFlex></div>
    <button mat-raised-button color="primary" (click)="onOkClick()" cdkFocusInitial>{{ 'button.save' | translate
    }}</button>
    <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
  </div>

</form>